<script lang="ts">
  import Button from './Button.svelte';
  import Icon from './Icon.svelte';
  import Input from './Input.svelte';
  import { addToast } from './toast/store.js';
  import SelectWithLabel, { SelectOption } from './form/SelectWithLabel.svelte';

  export let search: string = '';
  export let toggleCreateOrEditModalOpen: () => void;
  export let updateEntryList: (() => Promise<void>) | undefined = undefined;
  export let toggleImportModalOpen: (() => void) | undefined = undefined;
  export let toggleExportModalOpen: (() => void) | undefined = undefined;
  export let publishEntries: () => void;
  export let createNewEntryLabel: string = 'Weiterleitung hinzufügen';

  export let selectLabel: string = '';
  export let selectPlaceholder: string = '';
  export let selectOptions: SelectOption[] | [] = [];
  export let selectedOption: string = '';
  export let onSelectOptionChange: ((event: Event) => Promise<void>) | undefined = undefined;
  export const filterOnLeft: boolean = false;

  const searchEntries = async () => {
    if (!updateEntryList) {
      return;
    }

    try {
      await updateEntryList();
    } catch (e) {
      addToast({
        type: 'error',
        message: 'Die Suche konnte nicht ausgeführt werden'
      });
    }
  };
</script>

<div class="action-bar">
  {#if updateEntryList}
    <form class="search-form" on:submit|preventDefault={searchEntries}>
      <Input
        placeholder="Bitte geben Sie einen Suchbegriff ein"
        bind:value={search}
        onReset={async () => {
          search = '';
          searchEntries();
        }}
      />
      <Button type="submit">Suchen</Button>
    </form>
  {/if}

  {#if onSelectOptionChange}
    <SelectWithLabel
      label={selectLabel}
      placeholder={selectPlaceholder}
      options={selectOptions}
      bind:selectedOption
      on:change={onSelectOptionChange}
    />
  {/if}

  <div class={`button-group ${!updateEntryList ? 'alignRight' : ''}`}>
    {#if publishEntries}
      <Button on:click={publishEntries}><Icon variant="publish" />Veröffentlichen</Button>
    {/if}
    {#if toggleImportModalOpen}
      <Button on:click={toggleImportModalOpen}><Icon variant="libraryAdd" />Importieren</Button>
    {/if}
    {#if toggleExportModalOpen}
      <Button on:click={toggleExportModalOpen}><Icon variant="arrowCircleDown" />Exportieren</Button
      >
    {/if}

    <Button variant="primary" on:click={toggleCreateOrEditModalOpen}
      ><Icon variant="create" />
      {createNewEntryLabel}
    </Button>
  </div>
</div>

<style lang="scss">
  @use '../styles/spacing';

  .action-bar {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: spacing.$xs;
    padding: spacing.$s 0;
  }
  .search-form {
    display: flex;
    gap: spacing.$xs;
  }
  .button-group {
    display: flex;
    justify-content: flex-end;
    gap: spacing.$xs;
    margin-left: auto;
  }
  .alignRight {
    margin-left: auto;
  }
</style>
